import React from "react";

import styles from "../../ElectoralGeographyPage.module.styl";

const EmptyState = ({ children }) => {
  return (
    <div className={styles.empty}>
      {children}
    </div>
  );
};

export default EmptyState;
